import React, { useContext } from "react";

import { OfferOptionsContext, SportOfferContext } from "@gp/components";
import { SportOffer } from "@gp/offer";
import { observer } from "mobx-react";

import { useOfferHistoryColumns } from "./OfferHistoryColumnsContext";

export const OfferHistoryResultHeader = observer(
	function OfferHistoryResultHeader() {
		const offerOptionsContext = useContext(OfferOptionsContext);
		const sport = useContext(SportOfferContext) as SportOffer;
		const columns = useOfferHistoryColumns();

		// @ts-expect-error isOfferHistory provided at runtime via SportsPageOptionsProvider, not on @gp/components OfferOptions type
		const isOfferHistory: boolean = offerOptionsContext.isOfferHistory;

		if (!isOfferHistory || sport?.isOutright) {
			return null;
		}

		return (
			<>
				{columns.hasResult && (
					<ResultHeaderColumn modifier="offer__result--ft" />
				)}
			</>
		);
	}
);

function ResultHeaderColumn(props: { modifier: string }) {
	return (
		<div className={`offer__head__data offer__result ${props.modifier}`} />
	);
}
